<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .salary-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    gap: utils.in_rem(4px);
    padding: utils.in_rem(6px) utils.in_rem(12px) utils.in_rem(8px)
      utils.in_rem(12px);
    border-radius: 8px;

    background-color: colors.get(interfaceSwGrey_4);

    .salary-item {
      display: flex;
      align-items: flex-start;
      gap: utils.in_rem(4px);

      .salary-left {
        @include mixins.title3();
        color: colors.get(textLighterBlack);
        width: utils.in_rem(120px);
      }

      .salary-right {
        @include mixins.body3();
        color: colors.get(textBlack);

        display: flex;
        flex-direction: column;

        gap: utils.in_rem(4px);
      }
    }
  }

  .bonus {
    @include mixins.body3();
    color: colors.get(textDisabledGrey);
  }

  .add {
    @include mixins.body3();
    color: colors.get(primary_50);

    &:hover {
      color: colors.get(primary_70);
      cursor: pointer;
    }
  }
</style>

<script>
  import PureButton from "@sourcewhale/shared/svelte-design-system/components/utils/PureButton.svelte";
  import { currenciesStore } from "../../../../api-stores/currencies-store";
  import { candidateStore, showEditContact } from "../stores";

  // NB 0 values are treated as nullish here (consistent with the edit contact UI)
  const formatAmount = (num, sym, pos) => {
    const formatted = num ? new Intl.NumberFormat("en-US").format(num) : null;
    if (formatted && sym)
      return pos === "before" ? `${sym}${formatted}` : `${formatted}${sym}`;
    return formatted;
  };

  const formatNoticePeriod = (notice) =>
    notice ? `${notice} month${notice === 1 ? "" : "s"}` : null;

  currenciesStore.once();

  let code = $derived($candidateStore?.salaryCurrency);
  let currencyObj = $derived(
    $currenciesStore?.currencies.find((c) => c.code === code)
  );
  let symbol = $derived(currencyObj?.symbol);
  let position = $derived(currencyObj?.position);

  let salary = $derived(
    formatAmount($candidateStore?.salary, symbol, position)
  );
  let bonus = $derived(
    formatAmount($candidateStore?.currentBonus, symbol, position)
  );

  let expectedSalaryMin = $derived(
    formatAmount($candidateStore?.expectedSalaryMin, symbol, position)
  );
  let expectedSalaryMax = $derived(
    formatAmount($candidateStore?.expectedSalaryMax, symbol, position)
  );
  let expectedBonusMin = $derived(
    formatAmount($candidateStore?.expectedBonusMin, symbol, position)
  );
  let expectedBonusMax = $derived(
    formatAmount($candidateStore?.expectedBonusMax, symbol, position)
  );

  let noticePeriod = $derived(
    formatNoticePeriod($candidateStore?.noticePeriod)
  );

  const openEditContact = () => {
    $showEditContact = true;
  };
</script>

{#snippet minOrMaxOrBoth(min, max)}
  {#if min && max}
    {min} - {max}
  {:else if min}
    {min}
  {:else if max}
    {max}
  {/if}
{/snippet}

{#snippet displayNumber(min, max)}
  <div>
    {#if min || max}
      {@render minOrMaxOrBoth(min, max)}
    {:else}
      <PureButton onclick={openEditContact}>
        <span class="add">Add</span>
      </PureButton>
    {/if}
  </div>
{/snippet}

{#snippet displayBonus(min, max)}
  {#if min || max}
    <div>
      {@render minOrMaxOrBoth(min, max)}
      <span class="bonus">(Bonus)</span>
    </div>
  {/if}
{/snippet}

<div class="salary-container">
  <div class="salary-item">
    <div class="salary-left">Current Salary</div>
    <div class="salary-right">
      {@render displayNumber(salary, null)}
      {@render displayBonus(bonus, null)}
    </div>
  </div>
  <div class="salary-item">
    <div class="salary-left">Expected Salary</div>
    <div class="salary-right">
      {@render displayNumber(expectedSalaryMin, expectedSalaryMax)}
      {@render displayBonus(expectedBonusMin, expectedBonusMax)}
    </div>
  </div>
  <div class="salary-item">
    <div class="salary-left">Notice Period</div>
    <div class="salary-right">
      {@render displayNumber(noticePeriod, null)}
    </div>
  </div>
</div>
